const doc = [({"sales_analysis":({"top_customers":({"table":({"headers":({"payments_count":"Totalul tranzacțiilor"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;